export interface CommentLikeState {
    count: number
    liked: boolean
}

const toCount = (value: unknown): number | null => {
    const parsed = Number(value)
    return Number.isFinite(parsed) && parsed >= 0 ? parsed : null
}

const userIds = (user: any) => [user?.id, user?.user_id, user?.corid, user?.cor_id]
    .filter((id) => id !== undefined && id !== null && String(id) !== '')
    .map(String)

const reactionUserId = (reaction: any) => {
    if (typeof reaction !== 'object' || reaction === null) return reaction
    return reaction?.user_id
        ?? reaction?.user?.id
        ?? reaction?.user?.user_id
        ?? reaction?.id
}

export const getCommentLikeState = (comment: any, user?: any): CommentLikeState => {
    const likes = Array.isArray(comment?.likes) ? comment.likes : null
    const likedBy = Array.isArray(comment?.liked_by_users)
        ? comment.liked_by_users
        : (Array.isArray(comment?.liked_by) ? comment.liked_by : null)
    const reactions = Array.isArray(comment?.reactions)
        ? comment.reactions.filter((reaction: any) => {
            const type = String(reaction?.type ?? reaction?.reaction ?? reaction?.name ?? 'like').toLowerCase()
            return type === 'like' || type === 'liked' || type === 'thumbs_up'
        })
        : null
    const collection = likes ?? likedBy ?? reactions

    const explicitCount = [comment?.likes_count, comment?.like_count, comment?.reactions_count]
        .map(toCount)
        .find((value): value is number => value !== null)
    const count = explicitCount ?? collection?.length ?? 0

    const explicitLiked = comment?.liked_by_current_user
        ?? comment?.is_liked ?? comment?.liked ?? comment?.liked_by_me
        ?? comment?.current_user_liked ?? comment?.user_has_liked
    if (typeof explicitLiked === 'boolean') {
        return { count, liked: explicitLiked }
    }

    const currentUserIds = new Set(userIds(user))
    const liked = currentUserIds.size > 0 && Boolean(collection?.some((reaction: any) => {
        const id = reactionUserId(reaction)
        return id !== undefined && id !== null && currentUserIds.has(String(id))
    }))

    return { count, liked }
}

export const withCommentLikeState = (comment: any, state: CommentLikeState) => ({
    ...comment,
    likes_count: Math.max(0, state.count),
    liked_by_current_user: state.liked,
    is_liked: state.liked,
})
